// extracted by mini-css-extract-plugin
export default {"closeToolbar":"WkRJ","scrollPanel":"NUwz"};